import { Button, Col, Row, Space, Alert, Tabs } from 'antd';
import { Input } from 'antd';
import { InfoCircleFilled } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import MapsAdministrationComponent from './administrationComponents/MapsAdministrationComponent';
import LayersAdministrationComponent from './administrationComponents/LayersAdministrationComponent';
import ToolsAdministrationComponent from './administrationComponents/ToolsAdministrationComponent';
import URSAdministrationComponent from './administrationComponents/URSAdministrationComponent';
import { MapService } from "../../service/mapService";
import { RoleService } from '../../service/rolService';

import { user_state } from '../../features/user/userSlice';
import { useDispatch, useSelector } from 'react-redux';
import { UserService } from '../../service/userService';
import { SecurityService } from '../../service/securityService';


const { TextArea } = Input;

const AdministradorComponent = () => {

    const [tabNames, setTabNames] = useState([
        {
            "id": 1,
            "name": "Mapas"
        },
        {
            "id": 2,
            "name": "Capas"
        },
        {
            "id": 3,
            "name": "Herramientas"
        },
        {
            "id": 4,
            "name": "Usuarios, Roles y Servicios"
        }
    ])


    const [dataMaps, setDataMaps] = useState([])
    const [dataRoles, setDataRoles] = useState([])
    const [dataUsers, setDataUsers] = useState([])
    const [dataServices, setDataServices] = useState([])

    const [content, setContent] = useState();

    const dispatch = useDispatch();
    const userstate = useSelector(user_state);


    const errorMessage = () => {
        return (
            <Alert
                message="Error"
                description="Error al cargar la página."
                type="error"
            />
        );
    }

    const onChange = (key) => {
        switch (key) {
            case 1:
                setContent(<MapsAdministrationComponent dataMaps={dataMaps} dataRoles={dataRoles}></MapsAdministrationComponent>)
                break;
            case 2:
                setContent(<LayersAdministrationComponent dataMaps={dataMaps} dataRoles={dataRoles}></LayersAdministrationComponent>)
                break;
            case 3:
                setContent(<ToolsAdministrationComponent dataMaps={dataMaps} dataRoles={dataRoles}></ToolsAdministrationComponent>)
                break;
            case 4:
                setContent(<URSAdministrationComponent dataRoles={dataRoles} dataUsers={dataUsers} dataServices={dataServices}></URSAdministrationComponent>)
                break;
            default:
                setContent(errorMessage())
                break;
        }
    };

    //Realizar las llamadas a base de datos para obtener los datos necesarios al principio para cada pestaña
    useEffect(() => {
        //console.log("carga los datos de los mapas")
        //console.log("estado", userstate)

        Promise.all([MapService.getMaps(), RoleService.getRoles(), UserService.getUsers(), SecurityService.getServicesCredentials()])
            .then((values) => {
                console.log(values)
                let dataMaps = values[0].lists
                let dataRoles = values[1].lists
                let dataUsers = values[2].lists
                let dataServices = values[3].lists
                setDataMaps(dataMaps)
                setDataRoles(dataRoles)
                setDataUsers(dataUsers)
                setDataServices(dataServices)
                setContent(<MapsAdministrationComponent dataMaps={dataMaps} dataRoles={dataRoles}></MapsAdministrationComponent>)
            }).catch((error)=> console.log(error))
    }, [])

    return (
        <Tabs
            onChange={onChange}
            type="card"
            size='large'
            items={tabNames.map((tab, i) => {
                return {
                    label: `${tab.name}`,
                    key: tab.id,
                    children: content,
                    style: { "padding": "20px" }
                };
            })}
        />

    );
}

export default AdministradorComponent;